module.exports = __webpack_public_path__ + "static/img/4.1f8f1d1.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/rollImg/rollSale/4.jpg
// module id = cZxs
// module chunks = 0